// @flow
import { combineReducers } from "redux";
import * as all from './all';

export default combineReducers(all);


// WEBPACK FOOTER //
// ./src/modules/reducers/index.js